module.exports = __webpack_public_path__ + "static/media/QRCode.6d135225.svg";